import { render, staticRenderFns } from "./qualityIndicatorsReport.vue?vue&type=template&id=06105d78&scoped=true&"
import script from "./qualityIndicatorsReport.vue?vue&type=script&lang=js&"
export * from "./qualityIndicatorsReport.vue?vue&type=script&lang=js&"
import style0 from "./qualityIndicatorsReport.vue?vue&type=style&index=0&id=06105d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06105d78",
  null
  
)

export default component.exports